import { TopArticles } from '#components/TopArticles';

import { ThemeImage } from '../base/ThemeImage';

import styles from './SearchNoResult.module.scss';
import NotFoundDark from './not-found-dark.svg';
import NotFoundLight from './not-found-light.svg';

type Params = { className?: string };

export function SearchNoResults({ className }: Params) {
	return (
		<>
			<section className={`${styles.wrapper} body1 ${className ?? ''}`}>
				<ThemeImage className={styles.image} srcLight={NotFoundLight} srcDark={NotFoundDark} alt="Keine Suchergebnisse gefunden" />

				<h2 className="heading1">Leider konnten wir keine Artikel zu diesem Thema finden.</h2>

				<p>Überprüfen Sie gegebenenfalls die korrekte Schreibweise oder suchen Sie nach einem ähnlichen Begriff.</p>
			</section>

			<TopArticles />
		</>
	);
}
